import { Navigate } from 'react-router-dom';

import AuthGuard from './components/guards/AuthGuard';
import AuthLayout from './layouts/Auth';
import HomeLayout from './layouts/Home';
import paginaLazy from './utils/paginaLazy';

// Telas de entrada: vão no bundle principal (são a primeira coisa que o usuário vê).
import ClerkSignIn from './components/auth/ClerkSignIn';
import ClerkSignUp from './components/auth/ClerkSignUp';
import LandingPage from './pages/landing/Landing';
import AprovacaoPendente from './pages/auth/AprovacaoPendente';
import Page404 from './pages/auth/Page404';
import CadastroWizard from './pages/onboarding/CadastroWizard';
import CadastroJuradoWizard from './pages/jurado/CadastroJuradoWizard';
import NovaInscricao from './pages/inscricoes/New';

// Demais telas: um chunk por página.
const Dashboard = paginaLazy(() => import('./pages/dashboards'));
const CheckoutPage = paginaLazy(() => import('./pages/checkout/CheckoutPage'));
const DetalhePerfil = paginaLazy(() => import('./pages/usuarios/perfil/Detail'));
const ListagemInscricoes = paginaLazy(() => import('./pages/inscricoes/List'));
const DesempenhoProduto = paginaLazy(() => import('./pages/inscricoes/DesempenhoProduto'));
const DesempenhoProdutoSumario = paginaLazy(() => import('./pages/inscricoes/DesempenhoProdutoSumario'));
const ResultadosConcurso = paginaLazy(() => import('./pages/resultados/ResultadosConcurso'));
const ResultadoProduto = paginaLazy(() => import('./pages/resultados/ResultadoProduto'));
const VotoPopular = paginaLazy(() => import('./pages/voto-popular/VotoPopular'));
const ConviteAceite = paginaLazy(() => import('./pages/jurado/ConviteAceite'));
const DashboardJurado = paginaLazy(() => import('./pages/jurado/DashboardJurado'));
const MesaDetalhe = paginaLazy(() => import('./pages/jurado/MesaDetalhe'));
const FichaAvaliacaoJurado = paginaLazy(() => import('./pages/jurado/FichaAvaliacaoJurado'));
const TreinamentoJurado = paginaLazy(() => import('./pages/jurado/TreinamentoJurado'));
const FichaAvaliacaoTreinamento = paginaLazy(() => import('./pages/jurado/FichaAvaliacaoTreinamento'));

/** Exige sessão no Clerk; sem login vai pro /login. */
const logado = (elemento) => <AuthGuard>{elemento}</AuthGuard>;

/** Área logada com o shell (sidebar + header); `paginas` são as rotas filhas. */
const areaLogada = (path, paginas) => ({ path, element: logado(<HomeLayout />), children: paginas });

const rotas = [
  // ── Públicas ──
  { path: '/', element: <Navigate to="/login" replace /> },
  { path: 'login/*', element: <ClerkSignIn /> },
  { path: 'registre-se/*', element: <ClerkSignUp /> },
  { path: 'landing', element: <LandingPage /> },
  { path: 'voto-popular', element: <VotoPopular /> },
  // Link do candidato no QR code: token imprevisível, não o id do produto
  { path: 'voto-popular/c/:token', element: <VotoPopular /> },
  // Convite de jurado, com layout próprio. /convite/:id atende os templates antigos
  // de WhatsApp, cuja URL ficou sem o prefixo /jurado.
  { path: 'jurado/convite/:id', element: <ConviteAceite /> },
  { path: 'convite/:id', element: <ConviteAceite /> },
  { path: 'aprovacao-pendente', element: <AuthLayout />, children: [{ index: true, element: <AprovacaoPendente /> }] },

  // ── Cadastros (wizard em tela cheia, sem o shell) ──
  { path: 'cadastro-produtor', element: logado(<CadastroWizard />) },
  { path: 'cadastro-jurado', element: logado(<CadastroJuradoWizard />) },

  // ── Área logada ──
  areaLogada('dashboard', [{ index: true, element: <Dashboard /> }]),
  areaLogada('checkout', [{ index: true, element: <CheckoutPage /> }]),
  areaLogada('perfil', [{ path: 'detalhe/:id', element: <DetalhePerfil /> }]),
  areaLogada('inscricoes', [
    { index: true, element: <ListagemInscricoes /> },
    { path: 'novo', element: <NovaInscricao /> },
    { path: 'desempenho/fases/:faseId/produtos/:produtoId', element: <DesempenhoProduto /> },
    { path: 'desempenho/produtos/:produtoId', element: <DesempenhoProdutoSumario /> },
  ]),
  areaLogada('resultados', [
    { index: true, element: <ResultadosConcurso /> },
    { path: 'produto/:produtoId', element: <ResultadoProduto /> },
  ]),
  areaLogada('jurado', [
    { index: true, element: <DashboardJurado /> },
    { path: 'mesas/:mesaId', element: <MesaDetalhe /> },
    { path: 'mesas/:mesaId/produtos/:produtoId', element: <FichaAvaliacaoJurado /> },
    { path: 'treinamento', element: <TreinamentoJurado /> },
    { path: 'treinamento/produtos/:idx', element: <FichaAvaliacaoTreinamento /> },
  ]),

  // 404 com a marca do cliente
  { path: '*', element: <Page404 /> },
];

export default rotas;
